import {React, useState} from 'react'

import './CPSMenu.scss'

const CPSMenu = ({labels, active, setActive}) => {    
    return (
        <div className="menu">
                {labels.map((item) => 
                <div className='items'
                    style={{backgroundColor: active==item ? '#232931': '#00000029',
                            color: active==item ? 'white': 'black'}} 
                    onClick={()=> setActive(item)} key={item}
                >
                    <label className='item'>
                        {item}
                    </label>
                </div>
                )}
        </div>
    )
}

export default CPSMenu;